import { Button, Paper, styled, Typography } from '@mui/material';

const RootPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  maxHeight: '100vh',
  boxSizing: 'border-box',
  padding: theme.spacing(3),
  '& h2': {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  '& .scar-textField': {
    marginBottom: theme.spacing(2),
  },
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  overflowY: 'auto',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(3),
}));

const ActionButtons = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const CancelButton = styled(Button)(({ theme }) => ({
  background: theme.palette.common.white,
  color: theme.palette.primary.main,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#f7f7f7',
    boxShadow: 'none',
  },
}));

const NotWorkingButton = styled(Button)(({ theme }) => ({
  background: 'transparent',
  color: theme.palette.primary.main,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#f7f7f7',
    boxShadow: 'none',
  },
}));

const CheckboxLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[300],
}));

const Steps = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const ErrorButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
}));

const NextButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
}));

const ModalSubtitle = styled(Typography)({
  margin: '1rem 0',
});

const ShowHideOtpKeyButton = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '0.75rem',
  marginRight: theme.spacing(1),
  cursor: 'pointer',
}));

const KeyCopiedMsg = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

const MandatoryNotice = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
  color: theme.palette.info.main,
}));

const MandatoryNoticeText = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  lineHeight: 1.4,
  color: theme.palette.info.main,
}));

export {
  RootPaper,
  Subtitle,
  ActionButtons,
  CancelButton,
  NotWorkingButton,
  CheckboxLabel,
  Steps,
  ErrorButton,
  NextButton,
  ModalSubtitle,
  ShowHideOtpKeyButton,
  KeyCopiedMsg,
  MandatoryNotice,
  MandatoryNoticeText,
};

// import { makeStyles } from '@mui/styles';
// import { ITheme } from 'theme/types';

// const useOTPStyles = makeStyles((theme: ITheme) => ({
//   root: {
//     width: '100%',
//     maxWidth: 600,
//     maxHeight: '100vh',
//     boxSizing: 'border-box',
//     padding: theme.spacing(3),

//     '& h2': {
//       marginTop: theme.spacing(1),
//       marginBottom: theme.spacing(2),
//     },
//     '& .scar-textField': {
//       marginBottom: theme.spacing(2),
//     },
//   },
//   subtitle: {
//     overflow: 'hidden',
//     overflowY: 'auto',
//     marginTop: `${theme.spacing(1)}px`,
//     marginBottom: `${theme.spacing(3)}px`,
//   },
//   actionButtons: {
//     marginTop: theme.spacing(2),
//   },
//   cancelBtn: {
//     background: theme.palette.white,
//     color: theme.palette.primary.main,
//     '&:hover': {
//       backgroundColor: '#f7f7f7',
//       boxShadow: 'none',
//     },
//   },
//   notWorkingBtn: {
//     background: 'transparent',
//     color: theme.palette.primary.main,
//     '&:hover': {
//       backgroundColor: '#f7f7f7',
//       boxShadow: 'none',
//     },
//   },
//   checkboxLabel: {
//     color: theme.palette.grey[300],
//   },
//   steps: {
//     marginBottom: theme.spacing(1),
//   },
//   errorBtn: {
//     backgroundColor: theme.palette.pink,
//     color: theme.palette.white,
//   },
//   nextBtn: {
//     backgroundColor: theme.palette.secondary.main,
//     color: theme.palette.white,
//   },
//   modalSubtitle: {
//     margin: '1rem 0',
//   },
//   showHideOtpKeyBtn: {
//     color: theme.palette.primary.main,
//     fontSize: '0.75rem',
//     marginRight: theme.spacing(1),
//     cursor: 'pointer',
//   },
//   keyCopiedMsg: {
//     marginLeft: theme.spacing(1),
//   },
// }));

// export default useOTPStyles;
